import React from 'react';

import './style.scss';

export const InfoLocalMapMo = ({ handleClick, selectedRegion }) => {
  return (
    <>
      <div className="info-map">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* 인천 */}
          <g
            className={'local ' + (selectedRegion === '인천' ? 'active' : '')}
            onClick={e => handleClick('인천', e)}
            onKeyUp={e => handleClick('인천', e)}
            id="area1"
          >
            <svg tabIndex="0" role="button" x="16.59" y="93.48" width="26" height="25" viewBox="0 0 26 25" fill="none">
              <path
                d="M6.05902 18.4947L4.95458 21.4246L10.236 24.1692L21.8569 15.9573L21.1028 18.5459L21.5383 18.8652L25.8368 14.5045L23.9345 10.2316L25.1922 8.48388L21.2974 6.49001L16.2009 0.484009H10.2627L8.44306 1.71738L7.59405 3.916L7.72299 6.91169L8.09276 6.88975C10.2627 6.763 16.0501 6.9385 16.7459 9.22C17.5195 11.7574 13.8899 14.5191 13.2501 14.9798L8.04897 14.8092L7.39214 11.6136L0.587891 11.872L6.06632 18.4947H6.05902Z"
                fill="currentColor"
              />
            </svg>
            <svg x="0" y="105" width="80" height="40" viewBox="0 0 80 40" fill="none">
              <text className="local-name" x="17%" y="70%" dominantBaseline="middle" aria-labelledby="area1">
                인천
              </text>
              <g>
                <svg x="20%" y="0" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '인천' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="23.5%" y="7.5%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="23%" y="10%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
            </svg>
          </g>
          {/* 경기기타 */}
          <g
            className={'local ' + (selectedRegion === '경기기타' ? 'active' : '')}
            onClick={e => handleClick('경기기타', e)}
            onKeyUp={e => handleClick('경기기타', e)}
            id="area2"
          >
            <svg tabIndex="0" role="button" x="9.71" y="39.22" width="116" height="124" viewBox="0 0 116 124" fill="none">
              <path
                d="M6.63551 50.5553L8.08296 48.0788L8.0854 48.0763L3.83305 48.9392L0.707031 47.2671L5.26834 40.0619L11.7904 42.4018L18.0497 38.7553L16.4636 37.1003L19.0958 23.7574L18.3003 21.064L19.5945 18.6557L22.8397 20.6472L27.0896 16.6741L29.0479 11.7796L33.4584 9.97825L32.9597 7.58219L38.9174 4.90582L52.611 0.220947L56.6882 4.27694L64.7526 3.94057L71.5252 7.48469L78.5314 14.5827L87.0021 17.515C88.936 19.0019 91.6801 21.1834 92.1715 21.7148C92.2323 22.1682 92.7456 23.2894 94.3366 26.58L94.4211 26.755C94.902 27.7508 95.3755 28.7312 95.4192 28.8786C95.4532 29.0492 95.5238 29.4002 101.087 33.1199L94.3682 44.8686L97.7448 52.125C95.1134 55.2222 95.5479 55.7152 95.7134 55.903L95.7135 55.9031C96.0541 56.2883 99.7713 59.0256 100.54 59.0256C100.91 59.0256 103.484 59.379 105.172 59.6252L111.339 63.4862H113.46L115.769 67.4398L113.57 69.5434L114.774 74.1259L115.576 77.6139L111.314 86.1013L110.397 98.73L99.9489 108.894L92.5632 112.022L86.0314 116.158V119.307L78.8939 123.58C78.1568 122.32 77.2932 120.979 76.5366 120.187C74.7486 118.313 68.9004 118.766 68.6522 118.791H68.6084L62.9232 120.66L59.9918 119.77L52.9297 120.326L45.853 115.156L40.1289 109.64L41.5763 103.6L42.6394 102.866L41.0825 100.502L37.993 103.507L34.1834 98.7665L26.5471 94.3742L29.0163 85.5309L39.635 86.8399L35.4046 83.3323L37.7035 80.3317L34.6237 78.7279L33.5265 76.5146L29.1306 73.3045L33.473 68.8974L37.0442 67.4666L40.686 70.4038L46.3493 69.4288L51.6088 71.8663L60.6268 63.7909L59.8848 60.6416L61.2276 59.4985L60.527 55.1012L55.3308 55.713L54.309 43.4622H50.4143L48.7065 44.8588L44.588 43.3671L42.3086 48.5492L39.7104 48.8417L36.9737 50.448V54.7624L35.4046 55.1865L32.1131 53.0172L30.3217 53.8015L29.1306 50.5553L25.2457 47.8794H20.4516L15.0936 50.9815L13.6836 55.6607L11.3817 56.0713L6.63551 50.5553Z"
                fill="currentColor"
              />
            </svg>
            <svg x="48" y="115" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '경기기타' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="58%" y="58%" dominantBaseline="middle" aria-labelledby="area2">
                경기기타
              </text>
            </svg>
          </g>
          {/* 서울 */}
          <g
            className={'local ' + (selectedRegion === '서울' ? 'active' : '')}
            onClick={e => handleClick('서울', e)}
            onKeyUp={e => handleClick('서울', e)}
            id="area3"
          >
            <svg tabIndex="0" role="button" x="36.89" y="83.19" width="34" height="27" viewBox="0 0 34 27" fill="none">
              <path
                d="M32.9252 11.908L27.6757 12.5272L26.6467 0.189941H23.6838L21.8594 1.68426L17.9916 0.285016L15.8193 5.22626L12.9562 5.55048L10.7134 6.86685V11.323L8.28808 11.9763L5.04789 9.84086L3.78052 10.3723L3.47402 13.5267L0.890625 14.8772L1.76149 15.9059L6.28607 18.2193L4.77788 20.3182L6.46852 24.1137L10.1806 22.6267L13.8976 25.6251L19.4585 24.667L24.489 26.9999L32.8255 19.5332L32.0811 16.3715L33.4506 15.2063L32.9252 11.908Z"
                fill="currentColor"
              />
            </svg>
            <svg x="47" y="88" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '서울' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area3">
                서울
              </text>
            </svg>
          </g>
          {/* 경기고양 */}
          <g
            className={'local ' + (selectedRegion === '경기고양' ? 'active' : '')}
            onClick={e => handleClick('경기고양', e)}
            onKeyUp={e => handleClick('경기고양', e)}
            id="area4"
          >
            <svg tabIndex="0" role="button" x="23.51" y="87.5" width="16" height="10" viewBox="0 0 16 10" fill="none">
              <path
                d="M3.20824 5.7373L0.672235 7.39857L0.509766 7.36421L1.60262 3.40409L6.79369 0.5H11.1651L14.4437 2.87607L15.8098 5.78016L15.5536 8.83392L13.2486 10L9.50582 5.7373H3.20824Z"
                fill="currentColor"
              />
            </svg>
            <svg x="24" y="72" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '경기고양' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="58%" y="58%" dominantBaseline="middle" aria-labelledby="area4">
                경기고양
              </text>
            </svg>
          </g>
          {/* 강원 */}
          <g
            className={'local ' + (selectedRegion === '강원' ? 'active' : '')}
            onClick={e => handleClick('강원', e)}
            onKeyUp={e => handleClick('강원', e)}
            id="area5"
          >
            <svg tabIndex="0" role="button" x="62.17" y="0" width="173" height="150" viewBox="0 0 173 150" fill="none">
              <path
                d="M3.97661 42.5368L11.9169 42.2053L18.9644 45.8932L25.9317 52.9522L34.3537 55.8675L34.3999 55.904C39.9416 60.1623 39.9318 60.4353 39.9245 60.6547V60.7425C40.0802 61.3055 41.2698 63.7674 41.9948 65.2665C42.7732 66.8752 43.0408 67.4407 43.1162 67.6649C43.452 68.0549 46.2301 70.005 48.7796 71.7039L49.0642 71.894L42.1918 83.9084L45.6073 91.2477L45.4541 91.4257C44.4591 92.5835 43.396 94.0411 43.3157 94.475C43.9142 95.0551 47.084 97.2172 47.5608 97.2952C48.096 97.2952 51.9202 97.8509 52.3532 97.9143L52.4286 97.9241L58.5468 101.756H60.8773L63.6871 106.572L61.3834 108.778L62.4805 112.956L63.3441 116.712L59.0309 125.304L58.1308 137.711L61.6874 140.01L74.5321 133L76.8821 134.947L83.5647 136.434L89.2669 133.036L97.7984 135.912L99.4283 139.881L107.748 144.987L115.516 144.366L119.16 149.497C120.04 149.662 124.955 150.518 127.966 149.482C131.228 148.358 133.503 144.375 133.525 144.334L133.595 144.21L136.318 143.322L147.678 146.652L153.5 145.387L156.677 144.734L160.428 148.071L162.829 147.045L172.944 138.745C171.375 134.299 169.339 129.529 169.2 129.202L169.186 129.17L151.225 102.65L147.866 92.2471L147.844 92.1813L127.049 66.4925L103.97 18.4982L98.1073 3.42468L92.8697 0L90.5684 4.44356L78.4657 25.4914L57.1651 31.3877L43.7487 27.3292L27.8705 29.9252L10.7711 27.6412L0.171875 38.7611L3.96445 42.5368H3.97661Z"
                fill="currentColor"
              />
            </svg>
            <svg x="101" y="69" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <text className="local-name" x="85%" y="58%" dominantBaseline="middle" aria-labelledby="area5">
                강원
              </text>
              <g>
                <svg x="45%" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '강원' ? '#FF7053' : '#484848'} />
                </svg>
                <svg svg x="49%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="52%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
            </svg>
          </g>
          {/* 충남 */}
          <g
            className={'local ' + (selectedRegion === '충남' ? 'active' : '')}
            onClick={e => handleClick('충남', e)}
            onKeyUp={e => handleClick('충남', e)}
            id="area6"
          >
            <svg tabIndex="0" role="button" x="3.02" y="147.46" width="111" height="98" viewBox="0 0 111 98" fill="none">
              <path
                d="M11.4561 33.4979L13.9812 39.5112L15.3314 52.664L20.8512 63.7205L21.0701 63.7278C22.627 63.7741 24.9259 63.8448 25.5049 63.874L25.5949 63.9764L25.8504 63.8424C26.0207 63.753 26.0069 63.302 25.809 62.4895C25.6631 61.8899 25.4563 61.0344 25.2057 60.0057C24.7046 57.9509 24.038 55.2136 23.369 52.4739C22.267 47.9596 21.1626 43.4454 20.8098 41.9975L24.7605 42.1974L27.1713 40.1572L28.3609 54.7846L30.6622 59.5231L30.0954 75.44L30.1319 86.2795L37.6173 94.8961L44.3826 94.2526L50.659 90.5768L53.442 89.4751L55.7944 84.4587L58.9058 81.7507L62.6279 82.516L69.437 81.5337V81.9554C69.437 81.9798 69.454 84.4831 70.9258 87.3618C72.0594 89.575 78.8904 88.0784 81.5421 87.2813L85.5366 83.3228L92.4892 90.1722L90.2219 93.1947L99.6778 97.999L103.125 94.0235L106.334 95.2032L109.854 94.5743L110.085 91.6835L110.837 87.898L108.243 83.3253L107.214 79.3497L100.225 73.7484L95.5228 76.978L91.937 75.9299L89.9032 77.6873L87.8184 75.8421L84.1767 73.7581L82.7463 66.9892L83.7096 61.4195L86.1107 59.0064L87.0448 58.2312L85.2081 51.5427L78.8953 44.5398L77.7179 40.5716L81.0044 37.025L83.9139 37.8294L89.1126 31.3627L92.7592 29.9002L92.3019 27.587L85.9525 19.085L85.9379 19.0558C85.916 19.0095 83.6391 14.3928 82.0091 12.6841C80.7344 11.3484 76.3823 11.3777 74.7548 11.5044L68.9334 13.4178L65.9144 12.5013L58.3463 13.0961L53.5028 15.7213L46.4237 6.84633L29.4094 0.464966L12.6433 8.25522L8.442 15.9772L1.72776 23.5846L0.0175781 31.1116L6.84372 36.0183L11.4561 33.4882V33.4979Z"
                fill="currentColor"
              />
            </svg>
            <svg x="-15" y="160" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <text className="local-name" x="85%" y="58%" dominantBaseline="middle" aria-labelledby="area6">
                충남
              </text>
              <g>
                <svg x="45%" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '충남' ? '#FF7053' : '#484848'} />
                </svg>
                <svg svg x="49%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="52%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
            </svg>
          </g>
          {/* 충북 */}
          <g
            className={'local ' + (selectedRegion === '충북' ? 'active' : '')}
            onClick={e => handleClick('충북', e)}
            onKeyUp={e => handleClick('충북', e)}
            id="area7"
          >
            <svg tabIndex="0" role="button" x="87.56" y="133.84 " width="94" height="107" viewBox="0 0 94 107" fill="none">
              <path
                d="M41.0391 73.4712L42.4866 71.002L40.049 64.1258L42.1801 61.9613L40.0685 55.7871L42.5863 51.7458L47.352 52.3698L50.3515 45.7934H56.7762L57.9075 37.6887L61.1259 35.6071L69.9055 36.314L78.9892 37.969L82.6699 33.1915L80.3101 28.4043L84.8252 23.2246L93.4467 16.7482L90.165 12.1267L82.575 12.7361L73.8489 7.38086L72.2555 3.50037L64.3565 0.838623L58.6932 4.21211L51.5557 2.62287L49.4514 0.877616L36.6603 7.85861L32.7996 5.36506L22.3609 15.5197L14.8779 18.6884L8.76455 22.5665V25.7279L1.25969 30.2178C1.95544 31.456 2.47847 32.5066 2.58065 32.7138L8.98837 41.2938L9.59654 44.365L5.56556 45.9811L0.556641 52.2113L6.11048 57.079L10.6085 69.0666L13.4572 69.6736L16.2183 73.2957L18.797 76.2134L14.4327 81.5223L16.5492 87.0773L23.8619 92.937L24.9298 97.054L27.6106 101.78L27.1411 104.15C29.0168 104.544 37.9058 106.363 41.0026 106.095C44.6371 105.78 47.1257 105.451 48.5294 103.833C49.9209 102.231 53.4216 93.1174 53.8521 91.9864L52.5823 87.6526L49.3614 88.5081L41.4186 83.7257L40.701 79.2651L42.1217 77.9659L41.044 73.4712H41.0391Z"
                fill="currentColor"
              />
            </svg>
            <svg x="119" y="151" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '충북' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area7">
                충북
              </text>
            </svg>
          </g>
          {/* 세종 */}
          <g
            className={'local ' + (selectedRegion === '세종' ? 'active' : '')}
            onClick={e => handleClick('세종', e)}
            onKeyUp={e => handleClick('세종', e)}
            id="area8"
          >
            <svg tabIndex="0" role="button" x="81.54" y="184.86" width="16" height="21" viewBox="0 0 16 21" fill="none">
              <path
                d="M0.539062 3.77376L1.5535 7.18383L7.87121 14.1916L9.66653 20.729L15.1328 16.205L11.4935 6.50864L5.8764 1.58489L3.24179 0.858521L0.539062 3.77376Z"
                fill="currentColor"
              />
            </svg>
            <svg x="40" y="181" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <text className="local-name" x="25%" y="58%" dominantBaseline="middle" aria-labelledby="area8">
                세종
              </text>
              <g>
                <svg x="45%" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '세종' ? '#FF7053' : '#484848'} />
                </svg>
                <svg svg x="49%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="52%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
            </svg>
          </g>
          {/* 경북 */}
          <g
            className={'local ' + (selectedRegion === '경북' ? 'active' : '')}
            onClick={e => handleClick('경북', e)}
            onKeyUp={e => handleClick('경북', e)}
            id="area9"
          >
            <svg tabIndex="0" role="button" x="127.87" y="139.48" width="124" height="143" viewBox="0 0 124 143" fill="none">
              <path
                d="M122.014 94.4134L112.908 101.375L108.804 99.5199L108.632 97.1702L111.921 93.3384L109.211 83.5202L108.294 73.4338L112.526 57.1294L112.546 57.0538L110.087 42.7994L113.597 37.8732L113.611 37.7927C113.663 37.5173 114.828 30.9848 111.49 26.6412C110.437 25.2689 109.926 24.4913 109.68 24.0574L109.809 24.133L109.802 23.4846C109.802 23.3481 109.634 9.898 109.761 6.75607C109.807 5.57876 109.116 3.13881 108.204 0.484375L98.2149 8.67924L95.2933 9.92724L91.4691 6.52694L88.6544 7.10707L82.6554 8.41112L71.3336 5.09369L69.0931 5.8225C68.6626 6.54644 66.4342 10.0662 63.2084 11.1777C62.014 11.5896 60.569 11.7261 59.1775 11.7261C56.8421 11.7261 54.6527 11.341 54.0396 11.2216L45.2941 17.7906L41.178 22.5218L43.5231 27.2798L39.2926 32.7715L29.7905 31.0384L21.3125 30.3584L18.5831 32.1231L17.4105 40.5276H10.8203L7.79163 47.1673L2.95787 46.5336L0.873047 49.8803L3.01869 56.1544L0.892498 58.314L3.28871 65.0781L1.81935 67.5887L2.92866 72.2151L1.48122 73.5386L2.08209 77.2753L9.47019 81.7238L13.0803 80.7658L14.6178 86.0186L14.574 86.1332C14.4134 86.5573 10.6354 96.5169 9.07609 98.3158C7.69918 99.9026 5.53895 100.378 2.49322 100.69L4.74589 107.661L2.42996 111.527L2.94569 114.006L12.4624 118.735L20.0013 120.76L24.4434 126.93L27.2994 130.159L24.93 134.196L27.4478 136.487H33.0114L35.6776 135.668L38.1444 137.759H41.3434L45.4838 135.346L47.121 133.023L43.742 128.882L44.7783 127.398L47.2792 126.423L47.5686 125.44L45.8487 122.545L47.6927 119.437L49.5537 118.242L49.8335 116.836L44.6008 115.895L45.1019 112.392L51.748 110.92L54.3972 102.762L63.1403 99.3518L69.5699 104.002L68.3439 108.802L69.5967 111.186L66.8137 114.318L65.8333 121.133L62.4129 125.401L55.796 127.398L54.3632 129.518L55.56 132.633L49.7483 135.97L50.0743 137.962L54.0566 142.349L59.3186 140.316L65.8674 142.4L70.6865 141.138L76.7634 136.611L82.074 138.098C83.3658 137.85 86.6231 137.077 87.4819 136.214C88.6058 135.088 91.5469 131.341 91.5761 131.302L91.6272 131.237L91.7026 131.2L99.0129 127.627L104.465 134.593L108.727 133.455L110.298 131.551L115.139 134.006L115.674 131.488L119.654 109.738L123.026 99.7954L122.024 94.4182L122.014 94.4134Z"
                fill="currentColor"
              />
            </svg>
            <svg x="181" y="192" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '경북' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area9">
                경북
              </text>
            </svg>
          </g>
          {/* 대전 */}
          <g
            className={'local ' + (selectedRegion === '대전' ? 'active' : '')}
            onClick={e => handleClick('대전', e)}
            onKeyUp={e => handleClick('대전', e)}
            id="area10"
          >
            <svg tabIndex="0" role="button" x="86.49" y="200.93" width="19" height="24" viewBox="0 0 19 24" fill="none">
              <path
                d="M1.3879 8.78063L0.490234 13.9847L1.82335 20.2954L5.27292 22.2771L6.91012 23.7249L8.7614 22.1235L12.3958 23.1862L16.799 20.1613L14.5974 14.3844L18.8352 9.22912L16.6433 6.75019L14.0379 3.33281L11.0652 2.69907L10.3986 0.927002L3.58949 6.56738L1.3879 8.78063Z"
                fill="currentColor"
              />
            </svg>
            <svg x="89" y="202" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '대전' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                대전
              </text>
            </svg>
          </g>
          {/* 전북 */}
          <g
            className={'local ' + (selectedRegion === '전북' ? 'active' : '')}
            onClick={e => handleClick('전북', e)}
            onKeyUp={e => handleClick('전북', e)}
            id="area11"
          >
            <svg tabIndex="0" role="button" x="23.89" y="229.38" width="108" height="77" viewBox="0 0 108 77" fill="none">
              <path
                d="M105.75 10.7592C105.527 10.7812 105.298 10.8007 105.064 10.8202C104.836 10.8397 104.578 10.8494 104.298 10.8494C100.608 10.8494 92.7964 9.24553 90.9986 8.86528L90.8113 9.81103L90.5413 13.1992L86.2719 13.9597L83.3502 12.8847L79.8593 16.909L69.119 11.4515L71.5273 8.24372L65.5429 2.34986L61.9328 5.93054L61.8476 5.95735C60.8356 6.26448 51.9101 8.87747 50.2826 5.69654C49.0711 3.32973 48.7938 1.2408 48.7305 0.375488L42.6099 1.25786L39.1141 0.538796L36.3895 2.90804L33.9811 8.04629L30.9548 9.24309L24.6128 12.9627L17.8645 13.6038L16.023 19.0272L16.2103 22.4251L26.2087 21.8986L20.3653 30.1178L16.2881 32.6675L13.2448 38.5857L2.6115 44.8623V48.9963H15.3345L14.2957 52.5014L2.68205 56.533L0.886719 62.3367C2.61393 62.5 4.7912 62.9485 4.97122 64.177C5.17313 65.5639 9.84147 71.3164 10.7221 72.1403C10.9873 72.1159 11.3984 72.1744 12.026 72.2768C12.7023 72.3865 13.6389 72.562 14.8066 72.796C16.4292 73.1226 18.0615 73.4785 18.6186 73.6003L21.1365 71.0142L25.7951 61.7444L28.6632 62.3074L34.0711 59.4385L37.5182 64.9814L40.7294 67.4847L43.2716 66.0222L43.7776 62.6146L46.9766 63.4896V68.2525L48.3243 72.6059L50.9759 76.3791L57.4493 74.2512L68.8806 73.944L76.1786 71.0678L82.6788 73.0446L87.5101 74.9288V70.2683L91.3197 64.9424L86.469 54.8999L87.5345 47.8896L89.3979 46.1834L89.4782 35.3316L98.4305 29.5402L101.35 27.4585L106.395 24.9406L105.656 21.3843L107.947 17.5574L105.748 10.7495L105.75 10.7592Z"
                fill="currentColor"
              />
            </svg>
            <svg x="66" y="254" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '전북' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="42%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                전북
              </text>
            </svg>
          </g>
          {/* 대구 */}
          <g
            className={'local ' + (selectedRegion === '대구' ? 'active' : '')}
            onClick={e => handleClick('대구', e)}
            onKeyUp={e => handleClick('대구', e)}
            id="area12"
          >
            <svg tabIndex="0" role="button" x="171.65" y="239.17" width="25" height="36" viewBox="0 0 25 36" fill="none">
              <path
                d="M1.24397 27.9915L0.650391 28.8398L4.02941 32.9835L2.99551 34.4533L5.30901 35.365L10.6439 32.301L9.53703 29.415L11.3275 26.7631L17.9785 24.7594L21.1313 20.8228L22.1165 13.9906L24.7073 11.0728L23.5615 8.88886L24.7341 4.29906L19.0294 0.172363L10.9796 3.3143L8.30853 11.5384L1.74754 12.9912L1.41913 15.2946L6.69078 16.2428L6.2018 18.6827L4.22646 19.9527L2.69143 22.5364L4.35053 25.3347L3.87128 26.9678L1.24397 27.9915Z"
                fill="currentColor"
              />
            </svg>
            <svg x="179" y="244" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '대구' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                대구
              </text>
            </svg>
          </g>
          {/* 전남 */}
          <g
            className={'local ' + (selectedRegion === '전남' ? 'active' : '')}
            onClick={e => handleClick('전남', e)}
            onKeyUp={e => handleClick('전남', e)}
            id="area13"
          >
            <svg tabIndex="0" role="button" x="0" y="289.41" width="127" height="107" viewBox="0 0 127 107" fill="none">
              <path
                d="M125.654 59.2495L123.603 42.209L124.747 38.7721L118.611 36.4784L111.51 17.383V15.7207L106.426 13.739L100.208 11.8499L93.0266 14.6799L81.5735 14.987L74.6865 17.2514L71.6578 12.9395L70.242 8.36917V4.05237L68.3737 3.54294L67.9358 6.48499L64.6638 8.36673L60.9637 5.48318L60.9296 5.42713L57.8085 0.408325L52.7728 3.07981L50.1941 2.57523L45.7326 11.4502L42.8523 14.4069L42.6552 14.363C39.466 13.6561 35.8802 12.937 34.9655 12.8761L34.9533 12.9249L34.6395 12.92C34.2284 12.9005 32.6009 10.892 31.3091 9.21013C29.9882 7.49169 28.3826 5.24187 28.2439 4.2888C28.1466 3.62337 26.3999 3.22605 24.6581 3.06517L19.6152 19.372L15.9734 21.7486L17.4695 27.6303L24.4124 33.0123L16.1023 37.1048L9.42216 50.1528L11.0837 61.6163H16.4259L11.7259 69.6796L13.1369 77.5039L0.910156 89.9425V97.0405L7.25219 101.713L19.8146 97.3354L24.0281 90.3593L23.3639 81.8768L26.4827 83.8365L30.2436 101.472L34.6419 106.637L41.5483 104.002L39.5146 99.3L48.3088 104.195L62.776 99.3366L65.1941 94.2617L66.3351 90.0498L61.3043 90.3788L67.7047 83.3539L68.3031 76.7776L78.4596 70.072L87.9642 64.5755C88.6672 65.4383 89.9711 67.2396 89.9274 68.1586C89.8884 68.9824 87.283 71.0787 85.4488 72.3023L77.8563 77.2529L73.1466 87.6927L77.343 93.0454L77.4087 93.082C78.1531 93.4939 81.9286 95.5146 83.3226 94.8736C83.6169 94.737 83.8091 94.4982 83.8748 94.1789C84.2348 92.4629 85.1374 88.6189 85.1447 88.5799L85.2225 88.2436L80.1041 86.7274L82.7752 84.4338L85.7601 85.0724L89.4554 91.9607L93.878 87.1662L100.439 82.8031L98.9502 80.7312L102.186 79.5003L109.975 81.6526L110.153 77.0238L103.19 75.6124L96.4981 66.0623L99.2543 60.2465L96.6465 58.3939L98.2131 57.6018L101.023 58.3403L103.979 54.3209H104.811L103.957 59.776L109.153 65.1239L107.27 72.7094L113.128 78.9835L122.418 81.6599L122.426 77.4406L126.012 77.2626L126.695 69.7015L123.632 61.2458L125.651 59.2422L125.654 59.2495ZM74.1732 42.2724L71.344 44.6148L69.0281 43.067L64.1092 46.7232H60.5112L56.6894 42.3455L51.267 43.0109L49.6468 40.2639L51.1405 33.356L52.6998 32.5735L53.6023 29.9557L57.3025 29.4731L57.6868 31.406L61.2094 31.2646L63.5886 29.5315L66.6927 28.6809L71.5045 32.8417L75.915 34.3529L74.1708 42.2699L74.1732 42.2724Z"
                fill="currentColor"
              />
            </svg>
            <svg x="28" y="337" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '전남' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                전남
              </text>
            </svg>
          </g>
          {/* 광주 */}
          <g
            className={'local ' + (selectedRegion === '광주' ? 'active' : '')}
            onClick={e => handleClick('광주', e)}
            onKeyUp={e => handleClick('광주', e)}
            id="area14"
          >
            <svg tabIndex="0" role="button" x="49.42" y="318.49" width="45" height="30" viewBox="0 0 45 30" fill="none">
              <path
                d="M16.5137 0.488403L13.9107 1.20016L11.4634 2.9844L7.09671 3.16233L6.72451 1.28547L4.14828 1.62185L3.29441 4.09347L1.78127 4.85153L0.423828 11.1378L1.65477 13.2268L6.98724 12.5735L10.8455 16.9903H13.8693L19.0072 13.1707L21.2988 14.7039L23.5174 12.8685L25.0646 5.83385L21.1382 4.48591L16.5137 0.488403Z"
                fill="currentColor"
              />
            </svg>
            <svg x="56" y="313" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '광주' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                광주
              </text>
            </svg>
          </g>
          {/* 경남 */}
          <g
            className={'local ' + (selectedRegion === '경남' ? 'active' : '')}
            onClick={e => handleClick('경남', e)}
            onKeyUp={e => handleClick('경남', e)}
            id="area15"
          >
            <svg tabIndex="0" role="button" x="111" y="254" width="111" height="107" viewBox="0 0 111 107" fill="none">
              <path
                d="M83.9501 68.6323L91.4387 65.0638L91.4086 65.0336L92.8906 63.6773L92.3665 62.5019L93.1678 60.6272L96.0475 59.6688L103.072 52.0857L110.555 42.863L99.337 27.2387L98.9153 24.7673L94.0895 23.417L88.1854 27.8114L83.0223 29.1616L76.5157 27.094L71.0273 29.2159L66.5631 24.2971L66.1956 22.0427L63.7435 21.0782L63.1652 21.904L58.719 24.496H55.056L52.6884 22.4887L50.2966 23.2241H44.3383L41.1753 20.3428L43.5791 16.2499L41.0368 13.3745L36.7352 7.40089L29.343 5.41169L20.3061 0.920898L20.3964 1.36094L14.8719 4.1157L12.0102 6.15914L3.37086 11.747L3.29254 22.5249L1.38274 24.273L0.388672 30.8012L5.32886 41.0305L1.40683 46.5159V53.2551L8.34719 71.9175L14.8297 74.3407L13.5163 78.289L15.8237 97.4758L18.6794 104.968L29.4153 103.293L31.301 99.5193L33.2289 90.2061L37.7654 87.7588L39.6029 89.097L40.7897 92.762L46.23 94.287L50.152 91.6408L46.3987 87.367L49.4893 86.8064L53.0137 90.1639L55.9718 101.279L56.0079 101.412L63.37 106.252L67.1474 101.472L64.6352 95.1068L69.6055 92.1532L69.7501 100.411L75.6301 101.605L76.7266 97.7591C78.1424 97.4939 80.8896 96.8368 80.8896 95.6614C80.8896 94.5824 79.7871 87.0294 79.7389 86.71L77.6966 79.2535L77.9014 76.4023L73.9372 76.7338L70.0393 83.5031L67.7017 81.1462L65.4545 84.0517L62.147 83.3223L62.5446 79.8201L65.4726 76.7398L64.0869 71.369L66.0811 70.7601L67.6656 74.0514L72.3346 74.6421L74.8108 70.935L72.6841 68.0657L72.9311 64.7262L83.938 68.6504L83.9501 68.6323Z"
                fill="currentColor"
              />
            </svg>
            <svg x="137" y="291" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '경남' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                경남
              </text>
            </svg>
          </g>
          {/* 울산 */}
          <g
            className={'local ' + (selectedRegion === '울산' ? 'active' : '')}
            onClick={e => handleClick('울산', e)}
            onKeyUp={e => handleClick('울산', e)}
            id="area16"
          >
            <svg tabIndex="0" role="button" x="209.48" y="267.54" width="33" height="34" viewBox="0 0 33 34" fill="none">
              <path
                tabIndex="0"
                d="M28.4861 4.4637L27.1384 6.09926L22.1855 7.4228L16.8019 0.541748L10.0974 3.81776C9.68383 4.34426 7.08085 7.6422 5.9983 8.72689C4.95468 9.77257 1.62918 10.5258 0.478516 10.7598L0.85071 12.9413L12.1214 28.6461H16.5611L16.6681 28.7485C16.7532 28.8314 18.7432 30.7546 19.1105 31.1177C19.5557 31.3786 23.5964 32.7167 26.5862 33.6771L27.7198 31.1909V20.2587L31.6195 20.1953V13.1753L32.9842 6.74276L28.491 4.4637H28.4861Z"
                fill="currentColor"
              />
            </svg>
            <svg x="221" y="273" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '울산' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                울산
              </text>
            </svg>
          </g>
          {/* 부산 */}
          <g
            className={'local ' + (selectedRegion === '부산' ? 'active' : '')}
            onClick={e => handleClick('부산', e)}
            onKeyUp={e => handleClick('부산', e)}
            id="area17"
          >
            <svg tabIndex="0" role="button" x="202.54" y="296.37" width="34" height="33" viewBox="0 0 34 33" fill="none">
              <path
                tabIndex="0"
                d="M33.4634 5.35281H33.4574C29.9089 4.20751 26.0712 2.93564 25.7941 2.65232C25.529 2.3871 23.8843 0.795732 23.4445 0.373779H19.2935L11.7507 9.66879L4.55129 17.4448L1.83418 18.349L1.34619 19.4882L1.97275 20.8987L0.544922 22.2068L5.06338 32.3277L10.4675 30.7423L15.4378 28.3251L22.7938 31.5983L23.6855 28.078L18.8296 23.6535L26.4628 20.7179L33.4634 5.35281Z"
                fill="currentColor"
              />
            </svg>
            <svg x="215" y="301" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '부산' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                부산
              </text>
            </svg>
          </g>
          {/* 제주 */}
          <g
            className={'local ' + (selectedRegion === '제주' ? 'active' : '')}
            onClick={e => handleClick('제주', e)}
            onKeyUp={e => handleClick('제주', e)}
            id="area18"
          >
            <svg tabIndex="0" role="button" x="11.87" y="453.64" width="61" height="35" viewBox="0 0 61 35" fill="none">
              <path
                tabIndex="0"
                d="M59.3852 0.947444C58.4219 0.399007 57.4342 0.60863 57.1909 1.40325C56.9428 2.19788 57.5266 3.28014 58.4924 3.82614C59.4582 4.37702 60.441 4.16981 60.6867 3.38006C60.9373 2.58544 60.3534 1.49832 59.3852 0.945004V0.947444Z"
                fill="currentColor"
              />
              <path
                d="M47.4788 2.8144L39.789 3.57978C39.789 3.57978 14.4477 7.8064 5.62427 17.0177C5.62427 17.0177 1.91927 20.8568 0.783203 25.4709L7.33202 34.6798C7.33202 34.6798 10.458 35.8328 12.7423 32.3764L22.1374 33.1418C22.1374 33.1418 30.681 31.6061 34.0917 32.3764L37.5072 27.7671L42.3531 28.5422L50.8967 25.4685C50.8967 25.4685 53.4559 18.5509 56.8739 16.6326V11.6381L54.03 7.03858C54.03 7.03858 48.6149 2.42928 47.4812 2.81196L47.4788 2.8144Z"
                fill="currentColor"
              />
            </svg>
            <svg x="32" y="460" width="80" height="22" viewBox="0 0 80 22" fill="none">
              <g>
                <svg x="0" y="4" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="8" fill={selectedRegion === '제주' ? '#FF7053' : '#484848'} />
                </svg>
                <svg x="3.5%" y="30%" className="plus" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.00022 0.648684L5 9.35132" stroke="white" strokeWidth="1.5" />
                  <path d="M9.35107 5.00049H0.648438" stroke="white" strokeWidth="1.5" />
                </svg>
                <svg x="6.5%" y="34%" className="check" width="11" height="8" viewBox="0 0 11 8" fill="none">
                  <path d="M9.04284 1.53845L4.06313 6.2937L1.57031 3.91749" stroke="white" strokeWidth="1.5" strokeLinecap="square" />
                </svg>
              </g>
              <text className="local-name" x="45%" y="58%" dominantBaseline="middle" aria-labelledby="area1">
                제주
              </text>
            </svg>
          </g>
          {/* --- 그 외 --- */}
          <g>
            {/* 울릉도 & 독도 */}
            <svg x="253.25" y="98.31" width="48" height="26" viewBox="0 0 48 26" fill="none">
              <path
                d="M7.34765 12.1958L0.253906 7.23548L4.22165 2.38729L4.30922 2.35317L9.36193 0.310547L11.9163 3.11123L13.3126 7.28911L11.184 10.5164L7.35009 12.1958H7.34765Z"
                fill="#31C1BB"
              />
              <path d="M21.9756 14.2916L17.7402 11.798L22.0218 8.89981L24.9216 8.23438L26.909 11.9418L21.9756 14.2916Z" fill="#31C1BB" />
            </svg>
          </g>
        </svg>
      </div>
    </>
  );
};
